var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.7999C17.9639 22.7999 22.7992 17.9646 22.7992 11.9999C22.7992 6.03527 17.9639 1.19995 11.9992 1.19995C6.03454 1.19995 1.19922 6.03527 1.19922 11.9999C1.19922 17.9646 6.03454 22.7999 11.9992 22.7999Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73371 5.69995L10.896 12.6023L5.70117 18.2142H6.87041L11.4186 13.3008L15.0932 18.2142H19.0719L13.619 10.9237L18.4544 5.69995H17.2852L13.0967 10.225L9.71238 5.69995H5.73371ZM7.45312 6.56112H9.2809L17.3522 17.353H15.5245L7.45312 6.56112Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.4b7bccc16c0a3cb116ee2d524cb6b76f.svg";
export { ForwardRef as ReactComponent };